import React from 'react';
import '../../assets/sass/auth.scss'
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import ThemeProvider from './ThemeProvider';

const AuthLayout = ({ 
    colProps = {
        sm: 10, md: 8, lg: 6,
    }, 
    ...props
}) => (
    <ThemeProvider floatSwitch>
        <div className="auth-wrapper" id={props.id}>
            <div className="auth-content">
                <Container>
                    <Row className="justify-content-center vh-100">
                        <Col {...colProps}>
                            <div className="d-flex flex-column justify-content-between h-100">
                                <div className="auth-card">
                                    {props.children}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    </ThemeProvider>
)

export default AuthLayout;
